import React, { useEffect, useState, useMemo } from 'react';
import { SelectControl, Row, Col } from '@design-system-etat/dsfr-react';
import * as PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getAPI } from 'store/apiReducer';
import { useFormContext } from 'react-hook-form';
import InputFiles from 'components/Commun/Form/InputFiles';
import { formaterOptions, getMessageErreurChampManquant } from '../../../utils/utils';
import usagerClientReducer from '../../../store/usagerReducer';
import {
    API_GET_REFERENTIEL_TYPE_JUSTIFICATIF_DOMICILE,
    CONTEXT_GET_REFERENTIEL_TYPE_JUSTIFICATIF_DOMICILE,
} from '../../../constants/apiUrls.constants';

const FormulaireJustificatifsDomicile = ({
    getApi,
    isLoading,
    isLoadingAdresse,
    typeJustificatifData,
    dataAdresse,
}) => {
    const hookForm = useFormContext();
    const { register, formState } = hookForm;
    const [optionEnCours, setOptionEnCours] = useState(null);

    useEffect(() => {
        if (
            isLoading === null &&
            !isLoadingAdresse &&
            (!typeJustificatifData || Object.keys(typeJustificatifData).length === 0)
        ) {
            getApi(
                usagerClientReducer,
                API_GET_REFERENTIEL_TYPE_JUSTIFICATIF_DOMICILE,
                CONTEXT_GET_REFERENTIEL_TYPE_JUSTIFICATIF_DOMICILE,
            );
        }
    }, [isLoading, typeJustificatifData, getApi, isLoadingAdresse, dataAdresse]);

    const optionsJustificatifData = useMemo(() => {
        if (typeJustificatifData) {
            if (
                dataAdresse &&
                dataAdresse.justificatifsDomicile &&
                dataAdresse.justificatifsDomicile.typeJustificatif
            ) {
                setOptionEnCours(
                    typeJustificatifData[dataAdresse.justificatifsDomicile.typeJustificatif],
                );
            }
            return Object.entries(typeJustificatifData).map((element) => {
                return {
                    key: element[0],
                    value: element[0],
                    libelle: element[1],
                };
            });
        }
        return [];
    }, [typeJustificatifData, dataAdresse]);

    return (
        <Row gutters>
            <Col col={12} lg={6}>
                <SelectControl
                    id="justificatif_domicile"
                    name="justificatifDomicile"
                    label="Sélectionnez votre type de justificatif de domicile *"
                    hintText="Pour être valable, un justificatif de domicile doit comporter le nom, le prénom et l'adresse de la personne et doit être daté de moins de 3 mois"
                    options={formaterOptions(optionsJustificatifData)}
                    state={formState.errors?.typeJustificatif ? 'error' : null}
                    message={formState.errors?.typeJustificatif?.message}
                    required
                    {...register('typeJustificatif', {
                        required: getMessageErreurChampManquant('Type de justificatif de domicile'),
                    })}
                    placeholder={optionEnCours || '-- Choisir une option --'}
                />
            </Col>
            <Col col={12} lg={6}>
                <InputFiles
                    label="Justificatif de domicile"
                    name="justificatifsDomicile"
                    multiple
                    error={formState.errors ? formState.errors.justificatifsDomicile : null}
                    required
                />
            </Col>
        </Row>
    );
};

FormulaireJustificatifsDomicile.propTypes = {
    isLoading: PropTypes.bool,
    typeJustificatifData: PropTypes.object,
    getApi: PropTypes.func.isRequired,
    dataAdresse: PropTypes.shape({
        numeroVoie: PropTypes.string,
        id: PropTypes.number,
        extension: PropTypes.string,
        libelleVoie: PropTypes.string,
        lieuDit: PropTypes.string,
        codePostal: PropTypes.string,
        ville: PropTypes.string,
        pays: PropTypes.shape({
            libelle: PropTypes.string.isRequired,
        }).isRequired,
        typeJustificatif: PropTypes.number,
        justificatifsDomicile: PropTypes.shape({
            fichiers: PropTypes.arrayOf(
                PropTypes.shape({
                    uuid: PropTypes.string.isRequired,
                    filename: PropTypes.string.isRequired,
                }),
            ),
            typeJustificatif: PropTypes.string,
        }),
    }),
    isLoadingAdresse: PropTypes.bool,
};

export default connect(
    (state) => {
        const { isLoading, data: typeJustificatifData } =
            state.referentiel.typeJustificatifDomicile;
        const { data: dataAdresse, isLoading: isLoadingAdresse } =
            state.monCompte.recuperationAdressePrincipale;
        return {
            dataAdresse,
            isLoadingAdresse,
            isLoading,
            typeJustificatifData,
        };
    },
    {
        getApi: getAPI,
    },
)(FormulaireJustificatifsDomicile);
